module.exports = __webpack_public_path__ + "static/img/kj1-6.977c7df.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/sougou/kj1-6.png
// module id = 924
// module chunks = 0